module.exports = __webpack_public_path__ + "static/media/ratchet.e0a7c9ea.mp3";